module.exports = __webpack_public_path__ + "img/lessonattend-finger-orange.8ceae7df.svg";